import { Country, EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const CreditSafeReportRelatedCompanySchema = z.object({
    companyId: z.string().optional(),
    name: z.string().optional(),
    country: EnumSchema(Country).optional(),
    address: z.string().optional(),
    status: z.string().optional(),
    relationship: z.string().optional(),
});

export class CreditSafeReportRelatedCompany extends FromSchema(CreditSafeReportRelatedCompanySchema) {
    companyId?: string;
    name?: string;
    country?: Country;
    address?: string;
    status?: string;
    relationship?: string;
}
